import { useMemo } from "react";
import { bool, func, node, oneOf, string } from "prop-types";
import { observer } from "mobx-react";
import {
  usePresetFieldNames,
  HeaderRow,
  PinnableCell,
  useEstimateTableSettings,
  useEstimateEditorSettings,
  ExpandContainer
} from "@tools";
import { capitalize, Grid } from "@material-ui/core";
import { TimelineSectionTitleCell } from "./components/TimelineSectionTitleCell";
import classnames from "classnames";

export const TimelineSectionTitleRow = observer(({
  code,
  action,
  children,
  className,
  ...expandProps
}) => {
  const { isProposal } = useEstimateEditorSettings();
  const { timelineLength } = useEstimateTableSettings();
  const { getFieldName } = usePresetFieldNames(isProposal);
  
  const ptClass = useMemo(() => `pt-timeline${capitalize(code)}`, [code]);
  
  return (
    <HeaderRow
      size="medium"
      className={classnames("preset-paperTimeline", className)}
      actionPresetClass="preset-paperTimeline"
      {...expandProps}
    >
      <PinnableCell
        pinnedLeft
        hasStaticWidth
        size="medium"
        allowOverflowDisplay
        containers={
          <ExpandContainer
            presetClassName="preset-timelineSubHeader"
            {...expandProps}
          />
        }
      >
        <Grid item container alignItems="center">
          <h3 className={classnames("capitalize preset-timelineSubHeader", ptClass, children && "mr-2")}>
            { getFieldName(ptClass) }
          </h3>
          { action }
        </Grid>
        { children }
      </PinnableCell>
      <Grid item container wrap="nowrap" className="month-container">
        {
          [...new Array(timelineLength).keys()]
            .map((_, i) => (
              <TimelineSectionTitleCell key={`month${i}`} monthIndex={i} />
            ))
        }
      </Grid>
    </HeaderRow>
  );
});

TimelineSectionTitleRow.propTypes = {
  code: oneOf(["sections", "team", "billing"]).isRequired,
  action: node,
  children: node,
  expandable: bool,
  expanded: bool,
  onExpand: func,
  className: string,
};